<div class="main-div">
    <div class="container">
        <mat-card class="card">
            <img src="/assets/GPTM-logo.png" alt="GPTM Icon" style="width:20%;height:20%;">
            <h2 class="header">Welcome to Golf Player Time Management</h2>
            <h3>Admin Portal</h3>
            <p><strong>If you are a first time user, enter your course information in the course overview tab</strong></p>
        </mat-card>
    </div>
</div>
